<template>

    <AppHead title="New episode" />

    <!-- <section class="px-4 xl:px-0">
        <SectionHeading class="md:flex hidden" :title="template && 'headline' in template ? 'New ' + template.name : 'New Episode'" />
        <MobileHeader :title="template && 'headline' in template ? 'New ' + template.name : 'New Episode'">
            <template v-slot:left>
                <Link :href="route('studio.index')" class="text-gray-800 pr-2.5 py-1">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                </Link>
            </template>
            <template v-slot:right>
                <div @click="form.post(route('episodes.store'))" class="font-medium text-regal-blue-700">
                    Publish
                </div>
            </template>
        </MobileHeader>
    </section> -->


    <section class="px-4 xl:px-0 mb-12 pt-6 md:pt-0">
        <SectionHeading importance="2" title="Set up your podcast" />
        <SetUpPodcast :podcasts="podcasts" :categories="categories" v-model:selected="form.podcast" :template="template"/>
        <InlineError v-if="form.errors.podcast" :message="form.errors.podcast"/>
    </section>

    <section class="px-4 xl:px-0 pb-24">
        <SectionHeading importance="2" title="Create your episode" />
        <!-- <div class="text-regal-blue-800 mb-8 flex space-x-2.5 items-center justify-between w-full bg-regal-blue-100 text-sm rounded-lg p-4 py-5">
            <div class="flex space-x-2.5 items-center flex-1">
                <div class="shrink-0 w-14 h-14 rounded-full bg-white flex items-center justify-center">
                    <svg class="w-6 h-6 text-regal-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path></svg>
                </div>
                <div class="">
                    <div class="text-base font-medium">
                        Get expert editing help.
                    </div>
                    <div class="">
                        Just upload your episode, and we'll take care of the rest.
                    </div>
                </div>
            </div>
            <div class="shrink-0">
                <div class="" @click="open = true">
                    <Button label="See options" type="primary outline" />
                </div>
            </div>

        </div> -->

        <div class="w-full bg-white rounded-2xl p-8 pt-9">
            <UploadAudio v-model:form="form" :supportedAudioFileTypes="supportedAudioFileTypes" @uploading="updateSubmitStatus"/>

            <div class="space-y-8">
                <div class="grid grid-cols-1 md:grid-cols-4 items-center gap-y-1 md:gap-y-0 md:gap-x-6">
                    <div class="col-span-1 font-medium text-gray-800">
                        <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Episode title
                        </label>
                    </div>
                    <div class="col-span-3">
                        <input type="text" name="" v-model="form.title" class="rounded-lg w-full" required>
                        <InlineError v-if="form.errors.title" :message="form.errors.title"/>
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-4 items-center gap-y-1 md:gap-y-0 md:gap-x-6">
                    <div class="col-span-1 font-medium text-gray-800">
                        <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Episode cover
                        </label>
                        <div class="text-xs text-gray-700">
                            PNG, JPG, GIF up to 10MB
                        </div>
                    </div>
                    <div class="col-span-3">
                        <label for="cover-upload" ref="imageLabel"><Button label="Upload image" :type="buttonType" icon="UploadIcon" /></label>
                        <input id="cover-upload" type="file" accept="image/*" ref="image" class="hidden" @input="uploadEpisodeImage" />
                        <InlineError v-if="form.errors.image" :message="form.errors.image" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-4 items-top gap-y-1 md:gap-y-0 md:gap-x-6">
                    <div class="col-span-1 font-medium text-gray-800">
                        <label for="description" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Episode description
                        </label>
                    </div>
                    <div class="col-span-3">
                        <textarea v-model="form.description" name="description" rows="8" cols="80" class="w-full rounded-lg"></textarea>
                        <InlineError v-if="form.errors.description" :message="form.errors.description"/>
                    </div>
                </div>
                <div v-if="account.plan !== 'Light'" class="grid grid-cols-1 md:grid-cols-4 items-center gap-y-1 md:gap-y-0 md:gap-x-6">
                    <div class="col-span-1 font-medium text-gray-800">
                        <div class="">
                            Publish date
                        </div>
                        <div class="">
                            <div class="text-xs text-gray-700">
                                <svg class="inline w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                                All times are local ({{ timezone }})
                            </div>
                        </div>

                    </div>
                    <div class="col-span-3">
                        <input type="datetime-local" v-model="form.dateTime" name="" class="w-full rounded-lg">
                        <InlineError v-if="form.errors.dateTime" :message="form.errors.dateTime"/>
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-4 items-center gap-y-1 md:gap-y-0 md:gap-x-6">
                    <div class="col-span-1 font-medium text-gray-800">
                        <div class="">
                            Share
                        </div>
                        <div v-if="form.sharing == 'link'">
                            <div class="text-xs text-gray-700">
                                <svg class="inline w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                Anyone on the internet with this link can listen
                            </div>
                        </div>
                        <div v-if="form.sharing == 'members'">
                            <div class="text-xs text-gray-700">
                                <svg class="inline w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
                                Only signed-in {{ $page.props.auth.account.name }} users can listen
                            </div>
                        </div>
                    </div>
                    <div class="col-span-3">
                        <select v-model="form.sharing" name="" class="w-full rounded-lg">
                            <option value="members">Members of {{ $page.props.auth.account.name }}</option>
                            <option value="link">Everyone with the link</option>
                        </select>
                        <InlineError v-if="form.errors.sharing" :message="form.errors.sharing"/>
                    </div>
                </div>
                <div class="w-full flex justify-end space-x-3 pt-6">
                    <Button :href="route('studio.index')" label="Cancel" type="secondary"/>
                    <div @click="submit" >
                        <Button :label="submitLabel" :disabled="disabled"/>
                    </div>
                </div>
            </div>
        </div>

    </section>

    <Modal v-model:open="open">
        <component :is="component" @submit="switchToFileUpload" @back="switchToEditingConfigurator" :configuration="configuration" v-model:open="open" @update:open="resetModal" :fileTypes="supportedAudioFileTypes" />
    </Modal>

</template>

<script>
    import { ref, shallowRef, computed } from 'vue'
    import Layout from '@/Shared/Layout'
    import { useForm, usePage } from '@inertiajs/inertia-vue3'
    import SectionHeading from '@/Shared/SectionHeading'
    import Button from '@/Shared/Button'
    import InlineError from '@/Shared/InlineError'
    import UploadAudio from '@/Shared/UploadAudio'
    import SetUpPodcast from '@/Shared/SetUpPodcast'
    import MobileHeader from '@/Shared/MobileHeader'
    import Modal from '@/Shared/Modal'
    import EditingConfigurator from '@/Pages/Episodes/EditingConfigurator'
    import UploadFile from '@/Shared/UploadFile'

    export default {
        setup (props) {
            const account = computed(() => usePage().props.value.auth.account)
            const now = new Date();
            now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
            now.setMilliseconds(null)
            now.setSeconds(null)

            const form = useForm({
                title: null,
                audio: [],
                template: props.template ?? null,
                podcast: null,
                dateTime: now.toISOString().slice(0, -1),
                sharing: 'members',
                description: null,
                image: null,
            })

            if (props.recording) {
                form.audio.push({
                    name: props.recording.title,
                    content_type: 'audio/webm',
                    extension: 'webm',
                    lastModifiedDate: null,
                    uuid: props.recording.uuid,
                    key: props.recording.s3key,
                    bucket: null,
                    previewUrl: props.recording.previewUrl,
                })
            }

            const buttonType = ref('secondary')

            if (props.selectedPodcast) {
                form.podcast = props.selectedPodcast
            } else if (Object.keys(props.podcasts).length == 1) {
                form.podcast = props.podcasts[Object.keys(props.podcasts)[0]].uuid
            }
            const open = ref(false)
            const component = shallowRef('EditingConfigurator')
            const submitLabel = ref('Publish episode')

            const configuration = ref({})

            const disabled = ref(false)

            return { form, open, component, configuration, submitLabel, disabled, account, buttonType }
        },
        watch: {
            podcasts: {
                deep: true,
                handler(val, oldVal) {
                    if (Object.keys(val).length == Object.keys(oldVal).length + 1) {
                        this.form.podcast = val[Object.keys(val)[0]].uuid
                    }
                }
            },
            form: {
                deep: true,
                handler(val, oldVal) {
                    if (Date.parse(this.form.dateTime) > Date.now()) {
                        this.submitLabel = 'Schedule episode'
                    } else {
                        this.submitLabel = 'Publish episode'
                    }
                }
            }
        },
        components: { SectionHeading, Button, InlineError, UploadAudio, SetUpPodcast, MobileHeader, Modal, EditingConfigurator, },
        props: {
            users: Object,
            template: String,
            podcasts: Object,
            supportedAudioFileTypes: Array,
            categories: Object,
            timezone: String,
            selectedPodcast: String,
            recording: Object,
        },
        layout: Layout,
        methods: {
            switchToFileUpload(data) {
                this.configuration = data
                this.component = UploadFile
            },
            switchToEditingConfigurator(data) {
                this.component = EditingConfigurator
            },
            resetModal() {
                this.open = false
                this.configuration = null
                this.component = EditingConfigurator
            },
            updateSubmitStatus(status) {
                this.disabled = status
            },
            submit() {
                if (!this.disabled) {
                    this.form.post(route('episodes.store'))
                }
            },
            uploadEpisodeImage(e) {
                if (!e.target.files.length) {
                    return
                }
                Vapor.store(e.target.files[0], {
                    progress: progress => {
                        this.buttonType = 'busy'
                    }
                }).then(response => {
                    this.form.image = {
                        uuid: response.uuid,
                        key: response.key,
                        bucket: response.bucket,
                        name: e.target.files[0].name,
                        content_type: e.target.files[0].type,
                    }
                    this.buttonType = 'secondary'
                    this.$refs.image.classList.remove('hidden')
                    this.$refs.imageLabel.classList.add('hidden')
                })
            },
        },
    }
</script>
